import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const StrategicMediaPlanningPage = lazy(() => import('../pages/strategic-media-planning/page'));
const MediaBuyingPage = lazy(() => import('../pages/media-buying-experts/page'));
const PerformanceMeasurementPage = lazy(() => import('../pages/performance-measurement/page'));
const MediaConsultingPage = lazy(() => import('../pages/media-consulting/page'));
const CurrentsPage = lazy(() => import('../pages/currents/page'));
const ResultsPage = lazy(() => import('../pages/media-buying-results/page'));
const NeuromarketingArticlePage = lazy(() => import('../pages/neuromarketing-article/page'));
const OutdoorAdvertisingArticlePage = lazy(() => import('../pages/outdoor-advertising-article/page'));
const SocialAdvertisingArticlePage = lazy(() => import('../pages/social-advertising-article/page'));

const NotFound = lazy(() => import('../pages/NotFound'));

const RSCVACaseStudyPage = lazy(() => import('../pages/rscva-case-study/page'));
const CapitolCorridorCaseStudyPage = lazy(() => import('../pages/capitol-corridor-case-study/page'));
const UpscaleRestaurantCaseStudyPage = lazy(() => import('../pages/upscale-restaurant-case-study/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/strategic-media-planning',
    element: <StrategicMediaPlanningPage />,
  },
  {
    path: '/media-buying-experts',
    element: <MediaBuyingPage />,
  },
  {
    path: '/performance-measurement',
    element: <PerformanceMeasurementPage />,
  },
  {
    path: '/media-consulting',
    element: <MediaConsultingPage />,
  },
  {
    path: '/currents',
    element: <CurrentsPage />,
  },
  {
    path: '/media-buying-results',
    element: <ResultsPage />,
  },
  {
    path: '/neuromarketing-article',
    element: <NeuromarketingArticlePage />,
  },
  {
    path: '/outdoor-advertising-article',
    element: <OutdoorAdvertisingArticlePage />,
  },
  {
    path: '/social-advertising-article',
    element: <SocialAdvertisingArticlePage />,
  },
 
  {
    path: '/rscva-case-study',
    element: <RSCVACaseStudyPage />,
  },
  {
    path: '/capitol-corridor-case-study',
    element: <CapitolCorridorCaseStudyPage />,
  },
  {
    path: '/upscale-restaurant-case-study',
    element: <UpscaleRestaurantCaseStudyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
